import { message } from "antd";
import styles from "../../../constants/styles.json";
import SyncIcon from "../../../assets/images/syncIcon.svg";
import discount from "../../../assets/images/discount.svg";
import giftVoucher from "../../../assets/images/giftVoucher.svg";
import user_add from "../../../assets/images/user_add.svg";
import ParkedBillIcon from "../../../components/PointOfSale/Retail/SvgComponent/ParkedBill";
import SalesHistoryIcon from "../../../components/PointOfSale/Retail/SvgComponent/SalesHistoryIcon";
import db from "../../../database";
import { getPricingRules } from "../../../utils/pricingRulesCache";
import dayjs from "dayjs";
import messages from "../../../errors/messages.en-IN.json";
import useSessionStore from "../../../stores/useSessionStore";

const CartMenuButtons = ({
  themeJSON,
  posConfig,
  tillAccessData,
  tillData,
  cart,
  isOnline,
  selectedProductInCart,
  pricePrecision,
  handleKeyvalue,
  setIsparkedBill,
  setShowPreOrders,
  setAddToBagFlag,
  setOpenSalesRep,
  setManualDiscountInput,
  setSelectedManualDiscountTypeValue,
  manualDiscountForm,
  setManualDiscountModalVisible,
  setProductSearchInput,
  openDisplayParkedBillModal,
  clearReturnCartData,
  searchOrderHistory,
  setDateRange,
  errorMessage,
}) => {
  const handleDiscountClick = () => {
    if (selectedProductInCart) {
      const pr = getPricingRules();
      const index = pr.findIndex((md) => md.mPricingrulesId === selectedProductInCart?.mPricingruleId && md.manualDiscount === "Y");
      if (index !== -1) {
        const pricingRule = pr[index];
        if (pricingRule.type !== "TD") {
          let discountValue =
            pricingRule.discountType === "V"
              ? selectedProductInCart.discount
              : ((selectedProductInCart.discount / (selectedProductInCart?.realPrice * selectedProductInCart?.weight)) * 100).toFixed(pricePrecision);
          manualDiscountForm.setFieldsValue({ discountName: pricingRule.mPricingrulesId, discountValue });
          setManualDiscountInput(discountValue);
          setSelectedManualDiscountTypeValue(pricingRule);
        } else {
          const matchedPricingRule = cart?.manualDiscountData?.totalLevelDiscount?.findIndex((item) => item.pricingRule === pricingRule.mPricingrulesId);
          manualDiscountForm.setFieldsValue({
            discountName: pricingRule.mPricingrulesId,
            discountValue: cart?.manualDiscountData?.totalLevelDiscount[matchedPricingRule]?.discountValue,
          });
          setManualDiscountInput(cart?.manualDiscountData?.totalLevelDiscount[matchedPricingRule]?.discountValue);
          setSelectedManualDiscountTypeValue(pricingRule);
        }
      } else {
        manualDiscountForm.resetFields();
        setManualDiscountInput("");
        setSelectedManualDiscountTypeValue("");
      }
    }
    cart.items.length > 0 && setManualDiscountModalVisible(true);
    setProductSearchInput("");
  };

  const handleSyncClick = () => {
    let parkedBills = useSessionStore.getState().parkedList;
    if (cart.items.length > 0) {
      openDisplayParkedBillModal();
    } else if (parkedBills?.length > 0) {
      message.error(`${messages.errors.sync.clear_parked_bills}`);
    } else {
      if (isOnline) {
        handleKeyvalue("4");
      } else {
        errorMessage("Sync Failed", "Please check your network connection and try again");
      }
    }
  };

  const resolvePrefsDate = (value) => {
    if (!value || value === "null") return null;
    if (value === "today") return dayjs();
    const match = value.match(/^today\s*\+\s*(\d+)$/);
    if (match) return dayjs().add(parseInt(match[1]), "day");
    return null;
  };

  const handleManagePreOrdersClick = () => {
    if (cart.items.length > 0) {
      clearReturnCartData();
    } else {
      if (isOnline) {
        // Default Manage Pre-Orders to next 7 days so upcoming deliveries show
        // up on open, not just today's. User can widen via the RangePicker.
        const defaultDateValue = [dayjs().startOf("day"), dayjs().add(7, "days").endOf("day")];
        let orderDateValue = defaultDateValue;
        let deliveryDateValue = null;
        const prefs = posConfig?.preOrderPreferences;
        if (prefs) {
          try {
            const p = typeof prefs === "string" ? JSON.parse(prefs) : prefs;
            if ("date_from" in p || "date_to" in p) {
              orderDateValue = [resolvePrefsDate(p.date_from), resolvePrefsDate(p.date_to)];
            }
            if ("delivery_date_from" in p || "delivery_date_to" in p) {
              deliveryDateValue = [resolvePrefsDate(p.delivery_date_from), resolvePrefsDate(p.delivery_date_to)];
            }
          } catch (e) {
            // JSON parse error — fall back to defaults
          }
        }

        const uiRange = orderDateValue.every(Boolean) ? orderDateValue : defaultDateValue;
        if (typeof setDateRange === "function") setDateRange(uiRange);
        searchOrderHistory("orderDateSearchKey", orderDateValue, 0, false, true, deliveryDateValue !== null ? deliveryDateValue : true);
        setShowPreOrders(true);
      } else {
        errorMessage("Sync Failed", "Please check your network connection and try again");
      }
    }
  };

  return (
    <div
      data-zone="menuButtons"
      data-zone-label="Menu"
      tabIndex={-1}
      style={{
        width: "18%",
        paddingTop: "2%",
        paddingBottom: "1.5%",
        display: "flex",
        flexDirection: "column-reverse",
      }}
    >
      {/* Product Sync */}
      <div style={{ width: "100%", marginBottom: "0.01rem", display: tillAccessData?.productSync === "Y" ? "block" : "none" }}>
        <button
          className="cartMenuItems"
          id="sm-product-sync"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
          onClick={handleSyncClick}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", fontSize: "1vw" }}>
            <img src={SyncIcon} style={{ height: "2.5vh" }} color={"#fff"} />
            <span style={styles.screenStyles.mainScreen.posIcon}>Product Sync</span>
          </div>
        </button>
      </div>

      {/* Manual Discount */}
      <div style={{ width: "100%", marginBottom: "0.37rem", display: tillAccessData?.manualDiscount === "Y" ? "block" : "none" }}>
        <button
          className="cartMenuItems"
          id="sm-discount"
          style={{ backgroundColor: "#2F3856", border: "1px solid #2F3856", borderRadius: "7px", height: "9.5vh" }}
          onClick={handleDiscountClick}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
            <img src={discount} style={{ height: "2.6vh" }} color={"#fff"} />
            <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}>
              Manual Discount
            </span>
          </div>
        </button>
      </div>

      {/* Bags */}
      <div style={{ width: "100%", marginBottom: "0.37rem", display: posConfig?.showBags === "Y" ? "block" : "none" }}>
        <button
          className="cartMenuItems"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
          onClick={() => setAddToBagFlag(true)}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
            <img src={giftVoucher} style={{ height: "2.6vh" }} color={"#fff"} />
            <span style={styles.screenStyles.mainScreen.posIcon}>Bag</span>
          </div>
        </button>
      </div>

      {/* Sales Representative */}
      <div style={{ width: "100%", marginBottom: "0.37rem", display: posConfig?.showOrderSalesRep === "Y" ? "block" : "none" }}>
        <button
          className="cartMenuItems"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
          onClick={() => setOpenSalesRep({ flag: true, level: "order" })}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
            <img src={user_add} style={{ color: "#fff", height: "2.5vh" }} />
            <span style={styles.screenStyles.mainScreen.posIcon}>Sales Representative</span>
          </div>
        </button>
      </div>

      {/* Parked Bills */}
      <div style={{ width: "100%", marginBottom: "0.37rem", display: tillAccessData?.parkedBills === "Y" ? "block" : "none" }}>
        <button
          className="cartMenuItems"
          id="sm-parked-bill"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
          onClick={() => {
            handleKeyvalue("parked-bill");
            setIsparkedBill(true);
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
            <ParkedBillIcon color={"#fff"} />
            <span style={styles.screenStyles.mainScreen.posIcon}>Parked Bills</span>
          </div>
        </button>
      </div>

      {/* Manage Pre-Orders */}
      <div style={{ width: "100%", marginBottom: "0.37rem" }}>
        <button
          className="cartMenuItems"
          id="sm-sales-history"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
          onClick={handleManagePreOrdersClick}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
            <SalesHistoryIcon color={"#fff"} />
            <span style={styles.screenStyles.mainScreen.posIcon}>Manage Pre-Orders</span>
          </div>
        </button>
      </div>
    </div>
  );
};

export default CartMenuButtons;
